
var navigationButtonsIds = require('./navigationButtonsIds');
var constants = require('../../utils/domain/constants');
var storefrontUtility = require('../../utils/domain/storefrontUtility');
var staffActivities = require('../../utils/domain/staff/staffActivities');
var staffAccessUtility = require('../../utils/domain/staff/staffAccessUtility');
var staffUtility = require('../../utils/domain/staff/staffUtility');
var cashFloatUtil = require('../../utils/domain/cashFloatUtil');

export function canAccess (buttonId)
{
    if (buttonId == navigationButtonsIds.outstanding)
        return staffAccessUtility.canCurrentStaffPerformActivity(staffActivities.canPlaceAnOrder)

    if (buttonId == navigationButtonsIds.salesHistory)
        return staffAccessUtility.canCurrentStaffPerformActivity(staffActivities.canPlaceAnOrder)

    if (buttonId == navigationButtonsIds.cashingUp)
        return staffAccessUtility.canCurrentStaffPerformActivity(staffActivities.canDoCashingUp)

    if (buttonId == navigationButtonsIds.dailySummary)
        return staffAccessUtility.canCurrentStaffPerformActivity(staffActivities.canViewDailyReport)

    if (buttonId == navigationButtonsIds.driverSales)
        return staffAccessUtility.canCurrentStaffPerformActivity(staffActivities.canViewDriverSalesReport)

    if (buttonId == navigationButtonsIds.openCashDrawer)
        return staffAccessUtility.canCurrentStaffPerformActivity(staffActivities.canOpenCashDrawer)

    if (buttonId == navigationButtonsIds.overview)
        return staffAccessUtility.canCurrentStaffPerformActivity(staffActivities.canPlaceAnOrder)

    if (buttonId == navigationButtonsIds.notifications)
        return staffAccessUtility.canCurrentStaffPerformActivity(staffActivities.canPlaceAnOrder)

    if (buttonId == navigationButtonsIds.dineIn)
        return canTakeOrder(constants.DispatchTypeDineIn);

    if (buttonId == navigationButtonsIds.takeAway)
        return canTakeOrder(constants.DispatchTypeTakeAway);

    if (buttonId == navigationButtonsIds.collection)
        return canTakeOrder(constants.DispatchTypeCollection);

    if (buttonId == navigationButtonsIds.delivery)
        return canTakeOrder(constants.DispatchTypeDelivery);

    if (buttonId == navigationButtonsIds.staffMeal)
        return !cashFloatUtil.isCashFloatSessionClosedOrExpired() && storefrontUtility.getCurrentStorefrontVenueCode() == constants.VenueCodeProperty

    if (buttonId == navigationButtonsIds.voucher)
        return staffAccessUtility.canCurrentStaffPerformActivity(staffActivities.canApplyDiscount)
        
    if (buttonId == navigationButtonsIds.guestMeal)
        return  !cashFloatUtil.isCashFloatSessionClosedOrExpired() &&
                storefrontUtility.getCurrentStorefrontVenueCode() == constants.VenueCodeProperty &&
                staffUtility.inferStaffGuestMealLimit() > constants.numericThresholdValue;

    if (buttonId == navigationButtonsIds.freebies)
        return  !cashFloatUtil.isCashFloatSessionClosedOrExpired() &&
                storefrontUtility.getCurrentStorefrontVenueCode() == constants.VenueCodeProperty &&
                staffUtility.inferStaffFreebiesMealLimit() > constants.numericThresholdValue;

    return true;
}

function canTakeOrder (dispatchType)
{
    let storefront = storefrontUtility.getCurrentStorefront();
    let operatingConfiguration = storefront.operatingConfiguration ?? {};
    
    if (dispatchType == constants.DispatchTypeDineIn && !operatingConfiguration.dineInEnabled)
        return false;

    if (dispatchType == constants.DispatchTypeTakeAway && !operatingConfiguration.takeAwayEnabled)
        return false;

    if (dispatchType == constants.DispatchTypeCollection && !operatingConfiguration.collectionEnabled)
        return false;

    if (dispatchType == constants.DispatchTypeDelivery && !operatingConfiguration.deliveryEnabled)
        return false;

    if (!staffAccessUtility.canCurrentStaffPerformActivity(staffActivities.canPlaceAnOrder))
        return false;

    if (cashFloatUtil.isCashFloatSessionClosedOrExpired())
        return false;

    return true;
    
}